import { render, staticRenderFns } from "../../templates/form/sickness-form.pug?vue&type=template&id=439ae2cc&lang=pug&"
import script from "./SicknessForm.vue?vue&type=script&lang=js&"
export * from "./SicknessForm.vue?vue&type=script&lang=js&"
import style0 from "./SicknessForm.vue?vue&type=style&index=0&id=439ae2cc&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports